import React from 'react';
import {
  AlertTriangle,
  Award,
  BarChart3,
  CalendarDays,
  Coins,
  FileText,
  GraduationCap,
  NotebookTabs,
  Users,
} from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import MainLayout from '../../../app/layouts/MainLayout';
import ListItemCard from '../../../components/common/ListItemCard';
import { useTrimesters } from '../../trimesters/context/TrimestersContext';
import { reportDefinitions } from '../services/report.service';

const reportIcons = {
  coins: Coins,
  calendar: CalendarDays,
  school: GraduationCap,
  users: Users,
  alert: AlertTriangle,
  lesson: NotebookTabs,
  file: FileText,
  award: Award,
} as const;

const ReportsPage = () => {
  const navigate = useNavigate();
  const { currentTrimester, currentTrimesterId } = useTrimesters();

  return (
    <MainLayout>
      <div className="space-y-6">
        <header className="space-y-3">
          <div>
            <h1 className="text-2xl font-bold text-slate-900">Relatorios</h1>
            <p className="mt-1 text-sm font-medium text-slate-500">{currentTrimester.label}</p>
          </div>
        </header>

        <div className="space-y-3">
          {reportDefinitions.map((report) => {
            const Icon = reportIcons[report.iconKey as keyof typeof reportIcons] ?? BarChart3;

            return (
              <ListItemCard
                key={report.id}
                title={report.title}
                subtitle={report.description}
                leadingIcon={Icon}
                leadingTone={`from-slate-50 to-slate-50 ring-1 ring-slate-200 ${report.accentClassName}`}
                menuOpen={false}
                onToggleMenu={() => undefined}
                actions={[]}
                onClick={() => navigate(`/relatorios/${report.id}?trimester_id=${currentTrimesterId}`)}
              />
            );
          })}
        </div>
      </div>
    </MainLayout>
  );
};

export default ReportsPage;
